import actions from './actions';

const initState = {
	requestVocaList: [],
	loading: false,
	totalItems: 0,
};

export default function teacherReducer(state = initState, action) {
	switch (action.type) {
		case actions.GET_REQUEST_VOCA_LIST:
			return { ...state, loading: true, totalItems: 0 };

		case actions.GET_REQUEST_VOCA_LIST_SUCCESS:
			let { data, totalItems } = action.payload;
			let res = data ? data : [];
			return { ...state, requestVocaList: res, totalItems, loading: false };

		case actions.REQUEST_VOCA_LOADING_FALSE: {
			return { ...state, loading: false };
		}

		default:
			return state;
	}
}
